import { createApiClient } from "@/api";
import { type DataProviderSchema } from "@/utils";
import { getLocalFilteredSortedList } from "@/utils/listParams";

const apiClient = createApiClient("jsonld");
const BASE_URL = "/api/vpn/landings";

const fetchListData = async () => {
  const response = await apiClient.GET(BASE_URL, {
    params: {
      query: {
        pagination: false,
      },
    },
  });

  const data = response.data?.["hydra:member"] ?? [];
  const total = response.data?.["hydra:totalItems"] ?? 0;

  return {
    data,
    total,
  };
};

export const landingsSchema: DataProviderSchema<"Landing", "jsonld"> = {
  list: getLocalFilteredSortedList(fetchListData),
  detail: async ({ id }) => {
    const { data } = await apiClient.GET(`${BASE_URL}/{id}`, {
      params: {
        path: { id: String(id) },
      },
    });

    if (!data) throw new Error("Landings not found");

    return { data };
  },
  edit: async ({
    id,
    data: { title, appLandingId, showAcceptPrivacy, attributes = [] },
  }) => {
    if (!title) throw Error("Title is required");
    if (!appLandingId) throw new Error("Field 'appLandingId' is required");
    if (typeof showAcceptPrivacy !== "boolean")
      throw new Error("Field 'showAcceptPrivacy' is required");
    const { data } = await apiClient.PUT(`${BASE_URL}/{id}`, {
      params: {
        path: { id: String(id) },
      },
      body: {
        title,
        appLandingId,
        showAcceptPrivacy,
        attributes,
      },
    });

    if (!data) throw Error("Something went wrong");

    return { data };
  },
  create: async ({
    data: { title, appLandingId, showAcceptPrivacy, attributes = [] },
  }) => {
    if (!title) throw Error("Title is required");
    if (!appLandingId) throw new Error("Field 'appLandingId' is required");
    if (typeof showAcceptPrivacy !== "boolean")
      throw new Error("Field 'showAcceptPrivacy' is required");
    const { data } = await apiClient.POST(BASE_URL, {
      body: {
        title,
        appLandingId,
        showAcceptPrivacy,
        attributes,
      },
    });

    if (!data) throw new Error("Something went wrong!");

    return {
      data,
    };
  },
};
